import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { TenantProvider } from './tenant/TenantContext';
import { SearchProvider } from './search/SearchContext';
import TenantGuard from './tenant/TenantGuard';
import AppLayout from './components/AppLayout';
import InboxView from './views/InboxView';
import RulesView from './views/RulesView';
import SettingsView from './views/SettingsView';
import TenantPicker from './tenant/TenantPicker';

export default function App() {
  return (
    <AuthProvider>
      <TenantProvider>
        <SearchProvider>
          <BrowserRouter>
            <Routes>
              {/* Tenant Picker is shown when no tenant is selected */}
              <Route path="/select-mailbox" element={<TenantPicker />} />

              {/* All main routes require a tenant selection */}
              <Route element={<TenantGuard />}>
                <Route element={<AppLayout />}>
                  <Route index element={<InboxView />} />
                  <Route path="rules" element={<RulesView />} />
                  <Route path="settings" element={<SettingsView />} />
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
        </SearchProvider>
      </TenantProvider>
    </AuthProvider>
  );
}
